import {PropsWithChildren} from 'react';
import styles from './styles.module.less';

export function CardBody({children}: PropsWithChildren) {
	return <div className={styles.cardBody}>{children}</div>;
}
